import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getDisabledPartnerNames, getPartners } from '../selectors';
import { PartnerSchema } from '../types';
import DimensionItemsCell from './DimensionItemsCell';

const PartnersCell = ({ key, partners, baseSourceNames, operator, disabledPartnerNames, ...props }) => {
    const formattedPartners = partners.map(partner => ({
        ...partner,
        icon: partner.logoPath,
    }));
    const dimensionPartners =
        formattedPartners?.filter(partner => baseSourceNames.some(name => partner.name === name)) || [];

    return (
        <DimensionItemsCell
            key={key}
            allItems={formattedPartners.filter(partner => !disabledPartnerNames.includes(partner.name))}
            dimensionItems={dimensionPartners}
            itemType="PARTNERS"
            operator={operator}
            {...props}
        />
    );
};

PartnersCell.propTypes = {
    key: PropTypes.string.isRequired,
    partners: PropTypes.arrayOf(PartnerSchema).isRequired,
    baseSourceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    disabledPartnerNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    operator: PropTypes.string.isRequired,
};

export default connect(state => ({
    partners: getPartners(state),
    disabledPartnerNames: getDisabledPartnerNames(state),
}))(PartnersCell);
